module.exports = __webpack_public_path__ + "static/img/bg_1.b3fb087.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg_1.png
// module id = nC8M
// module chunks = 1